import { StyleSheet } from 'react-native';

import { Fonts } from '../Themes';

export default StyleSheet.create({
  primary: theme => ({
    color: theme.colors.text.primary,
  }),
  primaryWhite: theme => ({
    color: theme.colors.text.primaryWhite,
  }),
  secondary: theme => ({
    color: theme.colors.text.secondary,
  }),
  tertiary: theme => ({
    color: theme.colors.text.tertiary,
  }),
  textWithIcon: theme => ({
    color: theme.colors.text.textWithIcon,
  }),
  text: theme => ({
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.text.text,
    textAlign: 'left',
  }),
});
